import { isGoGameEnv } from 'App/constants';

import {
  ACTION_DELETE_PRESET,
  ACTION_RENAME_PRESET,
  ACTION_RESET_PRESET,
  ACTION_SHARE_PRESET,
  ACTION_UNSHARE_PRESET,
  ACTION_UPDATE_PRESET,
  ACTION_DUPLICATE_PRESET,
} from '../components/PresetActions/constants';

export const usePresetPermissions = ({
  isActive,
  isChanged,
  isPublic,
  isOwner,
}) => {
  let result = [];
  if (isActive) {
    result.push(ACTION_DUPLICATE_PRESET);
    if (isChanged) {
      result.push(ACTION_RESET_PRESET);
    }
    if (isChanged) {
      result.push(ACTION_UPDATE_PRESET);
    }
  }

  if (isOwner) {
    if (isGoGameEnv) {
      if (isPublic) {
        result.push(ACTION_UNSHARE_PRESET);
      } else {
        result.push(ACTION_SHARE_PRESET);
      }
    }
    result.push(ACTION_RENAME_PRESET);
    result.push(ACTION_DELETE_PRESET);
  }

  return result;
};
